
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retrospective-reviews",
      function () {
        return require("private-next-pages/retrospective-reviews.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/retrospective-reviews"])
      });
    }
  